export function processAuditedFinancialUnsecuredLoanData(auditedFinancialUnsecuredData: {
    headers: any[];
    rows: Array<Record<string, any>>;
}) {
    if (!auditedFinancialUnsecuredData) return null;
    let data = JSON.parse(JSON.stringify(auditedFinancialUnsecuredData));
    let rows = data?.rows ?? [];

    let debtRowToAdd: Record<string, any> = {
        classificationName: 'Unsecured Loans',
        label: 'Equity & Liabilities',
        parent: 'Debt',
        particular: 'Equity And Liabilities',
        subLabel: 'Non-current Liabilities',
    };

    const NON_NUMERIC_KEYS = ['classificationId', 'classificationName', 'id', 'label', 'parent', 'particular', 'subLabel'];

    // Accumulate at full float precision — applying toFixed on each iteration
    // introduces cumulative rounding error (e.g. three 0.15 values sum to 0.6
    // instead of 0.5 when each intermediate result is rounded).
    rows.forEach((row: any) => {
        Object.entries(row)
            .filter(([k]) => !NON_NUMERIC_KEYS.includes(k))
            .forEach(([key, val]) => {
                const num = Number(val);
                if (Number.isNaN(num)) return;
                debtRowToAdd[key] = (debtRowToAdd[key] ?? 0) + num;
            });
    });

    // Format once after accumulation is complete.
    Object.keys(debtRowToAdd).forEach((key) => {
        if (!NON_NUMERIC_KEYS.includes(key) && typeof debtRowToAdd[key] === 'number') {
            debtRowToAdd[key] = Number(debtRowToAdd[key].toFixed(1));
        }
    });

    data.rows.push(debtRowToAdd);
    return data;
}

export function formatCompanyMetricsValue(value: any, placeholder: string = '-'): string {
    if (value === null || value === undefined || value === '') return placeholder;
    const numericValue = parseFloat(String(value));
    if (!Number.isFinite(numericValue)) return placeholder;
    const hasDecimal = numericValue % 1 !== 0;
    const absValue = Math.abs(numericValue);
    const formatted = hasDecimal ? Math.trunc(absValue * 10) / 10 : absValue.toString();
    return numericValue < 0 ? `(${formatted})` : `${formatted}`;
}
